import React from 'react';

import { FormControl, FormHelperText, InputLabel, MenuItem, Select, colors } from '@material-ui/core';
import { Component } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { setError, setSuccess } from '../../redux/actions/MessageAction';
import { adminPanelBaseStyles } from '../../theme/style';
import { isLoggedInis } from '../../utils/CFuncs';
import { roles } from '../../utils/Objects';
import Alerts from '../common/Alerts';
class ClinicModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinic: {
        name: '',
        status: 1,
        location: '',
        email: '',
        phone: '',
        ...this.props.currentClinic,
      },
      statusOpen: false,
    };

    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    console.log('clinciModal');
    console.log(this.props.currentClinic);
  }

  onClick = () => {
    try {
      this.checkValidity();
      console.log('what is happedn');
      this.props.handleClick(this.state.clinic, this.closeModal);
      // this.closeModal();
    } catch (error) {
      console.log('checkValidity onClick error: ');
      console.log(error.message);
      this.props.setError(error.message);
    }
  };
  handleChange = ({ name, value }) => {
    console.log(name, value);
    this.setState({ clinic: { ...this.state.clinic, [name]: value } });
    this.props.setError('');
  };
  closeModal = () => {
    this.props.setError('');
    this.props.closeModal();
  };

  validateEmail(email) {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return regex.test(email);
  }

  validatePhone(input) {
    if (!input) return true;
    let regex = /^[0-9]+$/;
    return regex.test(input);
  }
  checkValidity = () => {
    const { name, location, email, phone } = this.state.clinic;
    if (name === '' || location === '') {
      throw new Error('fields cannot be empty ');
    }
    if (name.match(/\d/)) throw new Error('first name cannot contain numbres ');
    if (location.match(/\d/)) throw new Error('last name cannot contain numbres ');
    if (!this.validateEmail(email)) throw new Error('email must be valid email');
    if (!this.validatePhone(phone)) throw new Error('phone must be valid phone');

    return true;
  };

  handleStatusClose = () => {
    this.setState({ statusOpen: false });
    this.props.setError('');
    this.props.setSuccess('');
  };

  handleStatusOpen = () => {
    this.setState({ statusOpen: true });
  };

  render() {
    // / cehck that and put in thet other modal of the paitent
    const { name, location, email, phone } = this.state.clinic;
    console.log('modal render');
    console.log(this.state.clinic);
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.props.showModal}
        style={{
          content: { ...styles.centerModal },
        }}
        // onAfterOpen={afterOpenModal}
        onRequestClose={this.closeModal}
        // style={customStyles}
        contentLabel="Diagnosis Modal"
      >
        <div style={styles.container}>
          <AiOutlineCloseCircle
            style={styles.closeButton}
            onClick={() => {
              this.props.setError('');
              this.props.closeModal();
            }}
          />
          <div style={styles.title}>{this.props.title}</div>
          <div style={styles.insideContainer}>
            <dl>
              <dt>Name</dt>
              <dd>
                <input name="name" value={name} onChange={(e) => this.handleChange(e.target)} />
              </dd>

              <dt>Location</dt>
              <dd>
                <input name="location" value={location} onChange={(e) => this.handleChange(e.target)} />
              </dd>

              <dt>email</dt>
              <dd>
                <input name="email" value={email} onChange={(e) => this.handleChange(e.target)} />
              </dd>

              <dt>phone</dt>
              <dd>
                <input name="phone" value={phone} onChange={(e) => this.handleChange(e.target)} />
              </dd>
            </dl>

            <div
              onClick={() => {
                this.onClick();
              }}
              style={styles.button}
            >
              Save Changes
            </div>
          </div>
          <Alerts />
        </div>
      </Modal>
    );
  }
}

const styles = {
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  buttonClose: {
    position: 'absolute',
    top: 1,
    right: 1,
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  error: {
    color: 'red',
  },
  // buttonDisabled: {
  //   cursor: 'pointer',
  //   backgroundColor: '#9f9f9f',
  //   border: 'none',
  //   color: 'white',
  //   padding: 7,
  //   textAlign: 'center',
  //   textDecoration: 'none',
  //   display: 'inline-block',
  //   fontSize: 16,
  //   userSelect: 'none'
  // },
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
};
const mapStateToProps = (state, ownProps) => {
  return {
    error: state.message.error,
    login: state.login,
  };
};

const mapDispatchToProps = {
  setError,
  setSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClinicModal);
